import classNames from "classnames";
import { css } from "styled-components";
import tw from "twin.macro";

import { authThemeAccent, authThemeDark, authThemeHighlight } from "@glide/common-components";

export const MadeWithGlideIcon = () => {
    return (
        <svg viewBox="0 0 127 26" preserveAspectRatio="xMinYMin" xmlns="http://www.w3.org/2000/svg">
            <path
                d="m6.48 13.737 8.553-8.553v4.198a4.354 4.354 0 0 1-4.355 4.355H6.48ZM13.478 16.536a4.354 4.354 0 0 1 4.354-4.354h4.199l-8.553 8.553v-4.2ZM30.706 16.798h-1.31V8.611h1.579l2.608 6.222 2.608-6.222h1.58v8.187h-1.31v-5.625l-2.34 5.625h-1.064l-2.351-5.625v5.625ZM41.566 10.81c.764 0 1.376.207 1.836.62.46.405.69.97.69 1.696v3.672H42.84v-.9a1.951 1.951 0 0 1-.76.725c-.335.179-.698.269-1.088.269a2.32 2.32 0 0 1-1.029-.223 1.75 1.75 0 0 1-.702-.62 1.68 1.68 0 0 1-.245-.9c0-.577.222-1.025.666-1.345.453-.32 1.135-.526 2.047-.62l1.111-.117v-.082c0-.358-.117-.643-.35-.853-.227-.211-.535-.316-.925-.316-.358 0-.654.101-.888.304-.234.195-.37.468-.41.819l-1.146-.211a2.13 2.13 0 0 1 .819-1.392c.452-.35.994-.526 1.626-.526Zm-.316 5.1c.49 0 .877-.153 1.157-.457.281-.304.426-.702.433-1.193v-.245l-1.123.128c-.475.055-.838.168-1.087.34-.242.163-.363.374-.363.63 0 .235.09.426.27.574.179.148.416.222.713.222ZM48.093 16.892c-.585 0-1.092-.13-1.52-.386a2.547 2.547 0 0 1-.971-1.076c-.218-.46-.327-.987-.327-1.58 0-.592.109-1.118.327-1.578.226-.46.55-.819.97-1.076.422-.257.92-.386 1.498-.386.374 0 .721.078 1.04.234.328.148.581.347.76.596V8.518h1.276v8.28H49.87v-.748c-.14.249-.374.452-.702.608a2.47 2.47 0 0 1-1.076.234Zm.164-1.111c.515 0 .928-.176 1.24-.527.312-.358.467-.826.467-1.403 0-.585-.155-1.053-.467-1.404-.312-.35-.725-.526-1.24-.526s-.928.175-1.24.526c-.312.351-.468.819-.468 1.404 0 .577.156 1.044.468 1.403.312.351.725.527 1.24.527ZM58.11 13.629c0 .21-.007.386-.023.526h-4.503c.055.507.234.908.538 1.205.312.296.702.444 1.17.444.39 0 .713-.086.97-.257.258-.18.426-.43.504-.749l1.204.304a2.228 2.228 0 0 1-.947 1.322c-.476.312-1.06.468-1.755.468-.6 0-1.122-.14-1.567-.421a2.789 2.789 0 0 1-1.017-1.111 3.328 3.328 0 0 1-.351-1.51c0-.545.113-1.048.34-1.508.225-.46.553-.83.981-1.111.437-.28.956-.421 1.556-.421.608 0 1.13.133 1.567.398.437.257.768.604.994 1.04.227.43.34.89.34 1.38Zm-1.356-.445c-.04-.413-.195-.744-.468-.994-.265-.25-.624-.374-1.076-.374-.405 0-.745.12-1.017.362-.273.234-.457.57-.55 1.006h3.11ZM64.632 16.798h-1.17l-1.824-5.894h1.298l1.111 4.116 1.275-4.117h1.181l1.263 4.117 1.111-4.117h1.299l-1.813 5.895h-1.181l-1.275-4.105-1.275 4.105ZM72.483 16.798h-1.275v-5.894h1.275v5.894Zm-.643-6.877a.793.793 0 0 1-.585-.234.819.819 0 0 1-.234-.585c0-.234.078-.428.234-.584a.774.774 0 0 1 .585-.246c.242 0 .44.082.597.246.163.156.245.35.245.584a.799.799 0 0 1-.245.585.808.808 0 0 1-.597.234ZM77.34 16.751c-.28.094-.592.14-.935.14-.585 0-1.057-.163-1.415-.49-.351-.328-.527-.815-.527-1.463v-2.947h-1.029v-1.088h1.03V9.15h1.274v1.755h1.52v1.087h-1.52v2.877c0 .289.07.511.21.667.149.148.348.222.597.222.28 0 .519-.047.713-.14l.082 1.134ZM78.621 16.798v-8.28h1.275v3.403c.203-.366.468-.643.795-.83.335-.188.714-.281 1.135-.281.67 0 1.204.195 1.602.585.405.382.608.892.608 1.532v3.871h-1.275v-3.579c0-.39-.117-.698-.35-.924-.227-.226-.539-.339-.936-.339-.491 0-.877.203-1.158.608-.28.406-.421.967-.421 1.684v2.55H78.62ZM101.301 8.273a1.18 1.18 0 0 0-.424.71c-.087.582.323 1.03.92 1.03.609 0 1.118-.4 1.205-.958.1-.594-.31-1.055-.907-1.055a1.234 1.234 0 0 0-.794.273ZM96.143 13.152a5.94 5.94 0 0 0-.013-.816h-4.553l-.771 1.549h3.39c-.258.894-1.225 1.46-2.385 1.46-1.754 0-2.914-1.146-2.914-2.77 0-1.586 1.187-2.743 2.772-2.743 1.2 0 1.909.603 2.27 1.309h1.972c-.477-1.788-2.011-2.996-4.242-2.996-2.656 0-4.602 1.837-4.602 4.38 0 2.567 1.92 4.481 4.744 4.477 2.592 0 4.229-1.798 4.332-3.85ZM97.844 8.283l-1.392 8.585h1.78l1.392-8.585h-1.78ZM99.79 16.868l.954-5.916h1.779l-.953 5.916h-1.78Z"
                fill="currentColor"
            />
            <path
                d="M110.464 8.283h-1.779l-.542 3.31c-.322-.465-.902-.78-1.74-.78-1.418 0-2.926.932-3.236 2.845-.374 2.316 1.173 3.348 2.372 3.348.8 0 1.458-.315 1.922-.881l.383.743h1.976l-.445-1.58 1.089-7.005Zm-3.893 4.04c.683 0 1.418.605 1.25 1.662-.18 1.133-1.057 1.511-1.676 1.511-.812 0-1.405-.68-1.25-1.65.142-.918.825-1.522 1.676-1.522ZM116.859 14.476h-4.551c.193.756.735 1.133 1.483 1.133.683 0 1.043-.164 1.289-.53h1.612c-.387 1.373-1.663 1.926-2.863 1.926-1.921 0-3.171-1.322-3.171-3.097 0-1.762 1.289-3.096 3.12-3.096 1.83 0 3.095 1.336 3.095 3.098 0 .239 0 .327-.014.566Zm-4.564-1.158h2.954c-.116-.642-.735-1.095-1.47-1.095-.775 0-1.314.44-1.484 1.095Z"
                fill="currentColor"
            />
        </svg>
    );
};

interface MadeWithGlideProps {
    yOffset?: number;
    className?: string;
    position?: "absolute" | "static" | "relative";
    color?: string;
    background?: "none" | "filled";
}

export const MadeWithGlide: React.VFC<MadeWithGlideProps> = p => {
    const { yOffset = 0, className, position = "absolute", background = "filled", color = "var(--gv-n0)" } = p;
    return (
        <a
            data-testid="made-with-glide"
            id="made-with"
            href="https://glideapps.com/?utm_source=user-app&utm_medium=referral"
            target="_blank"
            rel="noreferrer"
            className={classNames(className, `pos-${position}`, `background-${background}`)}
            tw="all-child:h-7"
            css={css`
                transform: translateY(-${yOffset}px) scale(1);
                color: ${color};

                &.background-filled {
                    ${tw`bg-n900 rounded-lg transition shadow-lg page-hover:(shadow-2xl-xdark transform scale-105)`}
                }

                &.pos-absolute {
                    ${tw`absolute z-made-with-glide-badge right-4 bottom-4 page-md:right-5`}
                }

                &.pos-static {
                    ${tw`static block w-fit gp-sm:(mt-10) mt-5 mx-auto`}
                }

                &.pos-relative {
                    ${tw`relative block w-fit gp-sm:(mt-10) mt-5 mx-auto`}
                }

                .${authThemeHighlight} & {
                    ${tw`text-n400`}
                }
                .has-background-image &,
                .${authThemeDark} & {
                    ${tw`text-w30A`}
                }
                .${authThemeAccent} & {
                    ${tw`page-md:text-n400`}
                }

                .main-sign-in &.pos-static,
                .modal-sign-in &.pos-static,
                .main-sign-up &.pos-static,
                .modal-sign-up &.pos-static {
                    ${tw`absolute left-0 right-0 bottom-6 page-md:(static)`}
                }

                &.mobile {
                    ${tw`[box-shadow:unset] w-[136px]`}
                }

                &.desktop {
                    ${tw`[box-shadow:unset] w-[136px]`}
                }
            `}>
            <MadeWithGlideIcon />
        </a>
    );
};
